import type { NavNode } from "./types";

export const buildLabelMap = (nodes: NavNode[], acc: Record<string, string> = {}): Record<string, string> => {
  for (const n of nodes) {
    acc[n.id] = n.label;
    if (n.children) buildLabelMap(n.children, acc);
  }
  return acc;
};

export const collectIds = (nodes: NavNode[]): string[] =>
  nodes.flatMap((n) => [
    ...(n.groupOnly ? [] : [n.id]),
    ...(n.children ? collectIds(n.children) : []),
  ]);

export const buildAncestorMap = (nodes: NavNode[], parents: string[] = [], acc: Record<string, string[]> = {}): Record<string, string[]> => {
  for (const n of nodes) {
    acc[n.id] = parents;
    if (n.children) buildAncestorMap(n.children, [...parents, n.id], acc);
  }
  return acc;
};
